import * as React from 'react'
import { Button, Layout } from 'antd'
import { injectIntl, IntlShape } from 'react-intl'
import classNames from 'classnames'
import Iframe from 'react-iframe'
import { RouteComponentProps, withRouter } from 'react-router'
import { connect } from 'react-redux'
import styles from './TermsAndConditions.module.scss'
import logo from '../../assets/img/gett_delivery_wide.png'
import { deliveryHashKey } from '../../containers/DeliveryTracking/DeliveryTracking'
import { getRouteWithEnv } from '../../Routes'
import * as AnalyticsManager from '../../lib/analytics/analytics'
import { CountryCode, DeliveryTrackingData } from '../../store/DeliveryTracking/types'
import { ApplicationState } from '../../store'

class TermsAndConditions extends React.Component<RouteComponentProps & PropsFromState> {
  // todo @zhernosenko: fix that after getting correct pages
  static pathSwitch(country: string) {
    if (typeof country === 'undefined') {
      country = CountryCode.Israel
    }
    switch (country.toUpperCase()) {
      case CountryCode.Russia:
        return '../terms_and_conditions_ru.html'
      case CountryCode.Israel:
        return '../terms_and_conditions_il.html'
    }

    return '../terms_and_conditions_il.html'
  }

  componentDidMount(): void {
    AnalyticsManager.sendCurrentPageView()
  }

  render() {
    const { intl: { formatMessage }, history, deliveryData: { country } } = this.props
    const translate = (id: string, values: any = {}) => formatMessage({ id }, values)
    const { Header, Footer, Content } = Layout
    const backRedirect = (e: any) => {
      e.preventDefault()
      const deliveryHash = localStorage.getItem(deliveryHashKey)
      if (typeof deliveryHash === 'string') {
        return history.push(getRouteWithEnv(`/${deliveryHash}`))
      }
      return history.push(getRouteWithEnv('/'))
    }

    return (
      <Layout className={classNames(styles.layout)}>
        <Header className={classNames(styles.header)}>
          <img className={styles.companyLogo} src={logo} alt="Logo" />
        </Header>
        <Content className={styles.content}>
          <Iframe
            url={TermsAndConditions.pathSwitch(country)}
            className={styles.contentIframe}
            frameBorder={0}
            scrolling={'auto'}
          />
        </Content>
        <Footer className={styles.footer}>
          <Button
            className={classNames(styles.backButton)}
            onClick={backRedirect}
            htmlType='button'
          >
            {translate('terms_and_conditions.back_button')}
          </Button>
        </Footer>
      </Layout>
    )
  }
}

interface PropsFromState {
  deliveryData: DeliveryTrackingData
  intl: IntlShape
}

const mapStateToProps = ({ containers }: ApplicationState) => ({
  deliveryData: containers.DeliveryTracking.deliveryData,
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(TermsAndConditions)))
